import { render, staticRenderFns } from "./TermList.vue?vue&type=template&id=0d4c12fc&scoped=true"
import script from "./TermList.vue?vue&type=script&lang=js"
export * from "./TermList.vue?vue&type=script&lang=js"
import style0 from "./TermList.vue?vue&type=style&index=0&id=0d4c12fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c12fc",
  null
  
)

export default component.exports